$(document).ready(function() {
    var theModal = $('#CurrentCommission');
    if (theModal.length) {
        theModal.modal({ backdrop: false });
        theModal.show();
    }

    if ($('#startDate').length) {
        var today = new Date(Date.now());
        var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        $('#startDate').kendoDatePicker({
            value: firstDay,
            format: 'yyyy-MM-dd',
            change: function(e) {
                $('#lead-chart')
                    .data('kendoChart')
                    .dataSource.read();
            }
        });

        $('#endDate').kendoDatePicker({
            value: lastDay,
            format: 'yyyy-MM-dd',
            change: function(e) {
                $('#lead-chart')
                    .data('kendoChart')
                    .dataSource.read();
            }
        });

        $('#lead-chart').kendoChart({
            dataSource: {
                transport: {
                    read: {
                        url: '/' + URLSEGMENT + '/leadsfeedchart',
                        dataType: 'json',
                        data: function() {
                            return {
                                startDate: getStartDate(),
                                endDate: getEndDate()
                            };
                        },
                        type: 'POST'
                    }
                },
                change: function(e) {
                    updateChartInformation(this.data());
                },
                group: {
                    field: 'name'
                },
                sort: {
                    field: 'Day',
                    dir: 'asc'
                }
            },
            title: {
                text: 'Daily Leads'
            },
            chartArea: {
                height: 380
            },
            legend: {
                position: 'top'
            },
            series: [
                {
                    type: 'line',
                    field: 'Count'
                }
            ],
            categoryAxis: {
                field: 'Day',
                labels: {
                    rotation: 0,
                    template: "#= kendo.toString( new Date(value), 'd/MM') #"
                }
            },
            valueAxis: {
                field: 'Count',
                majorUnit: 1,
                title: {
                    text: 'Amount Of Leads',
                    rotation: -90
                }
            },
            tooltip: {
                visible: true,

                template: "#= dataItem.name #'s Leads : #= dataItem.Count # (#= kendo.format('{0:d}', dataItem.Day) #)"
            }
        });
    }

    if (typeof window.leadsGrid !== 'undefined') {
        $('#leads-grid').kendoGrid({
            selectable: false, //'multiple,row',
            sortable: true,
            filterable: window.getKendoGridFilterableSettings(),
            columns: [
                {
                    field: 'FirstName',
                    title: 'First Name',
                    width: '125px'
                },
                {
                    field: 'Surname',
                    title: 'Surname',
                    width: '125px'
                },
                {
                    field: 'Email',
                    title: 'Email',
                    width: '125px'
                },
                {
                    field: 'Mobile',
                    title: 'Phone',
                    width: '125px'
                },
                // {
                //     field: "HasBeenInterviewed",
                //     title: "Had Interview?"
                // },
                // {
                //     field: "HasBeenFinalised",
                //     title: "Been Finalised?"
                // },
                // {
                //     field: "HasBeenApproved",
                //     title: "Been Approved?"
                // },
                {
                    field: 'LeadProgress',
                    title: 'Status',
                    width: '500px',
                    template:
                        '<ul class="status-list # if(data.LeadProgress == "paid") { # complete # } #" data-status="#= data.LeadProgress #"><li class="new # if(data.LeadProgress == "new") { # active # } #"><span>New</span></li>' +
                        '<li class="appointment # if(data.LeadProgress == "appointment") { # active # } #"><span>Appointment</span></li>' +
                        '<li class="contract-signed # if(data.LeadProgress == "contract-signed") { # active # } #"><span>Contract Signed</span></li><li class="payable # if(data.LeadProgress == "payable") { # active # } #">' +
                        '<span>Payable</span></li><li class="paid # if(data.LeadProgress == "paid") { # active # } #"><span>Paid</span></li></ul>'
                },
                {
                    field: 'ReferringAffiliateName',
                    title: 'Affiliate',
                    width: '125px'
                },
                {
                    filterable: false,
                    title: '',
                    width: '100px',
                    template:
                        '# if (CanIEdit == 1) { #' +
                        '<a href="/affiliate/editcustomer/${ID}" id="edit-customer-${ ID }" data-record-id="${ ID }" class="edit-btn">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.5 21l-6.5 2 2-6.5 12-12 4.5 4.5zM15 4.5l3.086-3.085c.' +
                        '778-.778 2.05-.778 2.828 0l1.672 1.671c.778.779.778 2.051 0 2.829l-3.086 3.085M17.25 6.75l-10.75 10.75M3 16.5l1 1h2.5v2.5l1 1M2 20l2 2M16.5 3l4.5 4.5" ' +
                        'stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/></svg></a>' +
                        '# } #'
                }
            ],
            dataSource: window.leadsGrid,
            pageable: {
                pageSize: 10
            },
            filterMenuInit: function(filterElement) {
                var textFields = ['FirstName', 'Surname', 'Email', 'Mobile', 'LeadProgress', 'ReferringAffiliateName'];
                window.initializeTextFilterForKendoGrid(filterElement, textFields);
            }
        });
    }

    var grid = $('#leads-grid').data('kendoGrid');
    if (typeof isSales !== 'undefined' && !isSales) {
        grid.hideColumn(5);
    }

    $('.status-list').each(function() {
        var status = $(this).data('status');
        var elem;

        if (status == 'new') {
            elem = $(this).find('li:first-child');
            elem.addClass('active');
        } else if (status == 'appointment') {
            elem = $(this).find('li:nth-child(2)');
            elem.addClass('active');
        } else if (status == 'contract-signed') {
            elem = $(this).find('li:nth-child(3)');
            elem.addClass('active');
        } else if (status == 'payable') {
            elem = $(this).find('li:nth-child(4)');
            elem.addClass('active');
        } else if (status == 'paid') {
            elem = $(this).find('li:last-child');
            elem.addClass('active');

            $(this).addClass('complete');
        }
    });

    $('#leadUnprogressedStatusFilter, #leadPaidStatusFilter')
        .on('change', function() {
            var grid = $('#leads-grid').data('kendoGrid');
            if (grid) {
                var oldFilter = grid.dataSource.filter();
                var arrayFilter = [];
                if (typeof oldFilter !== 'undefined') {
                    // remove the previous filter
                    oldFilter.filters = $.grep(
                        oldFilter.filters,
                        function(f) {
                            return f.field === 'HasBeenInterviewed' || f.field === 'HasReferralBeenPaid';
                        },
                        true
                    );
                    arrayFilter = arrayFilter.concat(oldFilter.filters);
                }

                if (!$('#leadUnprogressedStatusFilter').is(':checked')) {
                    arrayFilter.push({
                        field: 'HasBeenInterviewed',
                        operator: 'eq',
                        value: true
                    });
                }

                if (!$('#leadPaidStatusFilter').is(':checked')) {
                    arrayFilter.push({
                        field: 'HasReferralBeenPaid',
                        operator: 'eq',
                        value: false
                    });
                }
                grid.dataSource.filter(arrayFilter);
            }
        })
        .trigger('change');
});

function getStartDate() {
    return (
        $('#startDate')
            .data('kendoDatePicker')
            .value()
            .getTime() / 1000
    );
}
function getEndDate() {
    return (
        $('#endDate')
            .data('kendoDatePicker')
            .value()
            .getTime() / 1000
    );
}

function updateChartInformation(data) {
    var isData = typeof data['0'] !== 'undefined';
    var total = 0;
    var stepAmt = 1;
    var dayStepAmt = 1;

    if (isData) {
        dayStepAmt = data[0].dayStepAmt;
        //stepAmt = data[0].StepAmt;
        total = data[0].Total;
    }

    var today = $('#startDate')
        .data('kendoDatePicker')
        .value();
    var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    var title = 'My Lead Total: ' + total + ' \n (' + firstDay.toDateString() + ' - ' + lastDay.toDateString() + ')';
    $('#lead-chart').data('kendoChart').options.title.text =
        "<tspan x='300' dy='0' text-anchor='middle'>Daily lead intake for each affiliate</tspan> " +
        "<tspan x='700' dy='0'text-anchor='middle'>(" +
        firstDay.toDateString() +
        ' - ' +
        lastDay.toDateString() +
        ')</tspan>' +
        "<tspan x='500' dy='1em'text-anchor='middle'>My Lead Total: " +
        total +
        '</tspan>';
    $('#lead-chart').data('kendoChart').options.valueAxis.majorUnit = stepAmt;
    $('#lead-chart').data('kendoChart').options.categoryAxis.labels.step = dayStepAmt;
}
